import {put, call, takeLatest, select} from 'redux-saga/effects';
import invoiceUploadApi from '../api/invoiceUpload.api';
import * as ActionTypes from '../actions/types.action';
import {getBearerHeader} from '../helpers/api.helper';

function* uploadInvoice(action) {
  try {
    const getAuth = state => state.auth;
    const storeToken = yield select(getAuth);
    const headers = getBearerHeader(null, storeToken);
    if (!headers) {
      yield put({type: ActionTypes.ERROR_REQUIRE_LOGIN});
      return;
    }
    const response = yield call(invoiceUploadApi.upload, action.files, headers);
    yield put({type: ActionTypes.UPLOAD_INVOICE_SUCCESS, response});
    yield put({type: ActionTypes.FETCH_UPLOADED_INVOICES_REQUESTED, page: 0});
  } catch (e) {
    yield put({
      type: ActionTypes.UPLOAD_INVOICE_FAILED,
      error: e.message || 'Upload failed',
    });
  }
}

function* fetchUploadedInvoices(action) {
  try {
    const getAuth = state => state.auth;
    const storeToken = yield select(getAuth);
    const headers = getBearerHeader(null, storeToken);
    if (!headers) {
      yield put({type: ActionTypes.ERROR_REQUIRE_LOGIN});
      return;
    }
    const data = yield call(
      invoiceUploadApi.list,
      action.page || 0,
      20,
      headers
    );
    yield put({type: ActionTypes.FETCH_UPLOADED_INVOICES_SUCCESS, data});
  } catch (e) {
    yield put({
      type: ActionTypes.FETCH_UPLOADED_INVOICES_FAILED,
      error: e.message || 'Failed to load invoices',
    });
  }
}

function* fetchUploadedInvoiceDetail(action) {
  try {
    const getAuth = state => state.auth;
    const storeToken = yield select(getAuth);
    const headers = getBearerHeader(null, storeToken);
    if (!headers) {
      yield put({type: ActionTypes.ERROR_REQUIRE_LOGIN});
      return;
    }
    const data = yield call(invoiceUploadApi.getDetail, action.id, headers);
    yield put({type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_SUCCESS, data});
  } catch (e) {
    yield put({
      type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_FAILED,
      error: e.message || 'Failed to load invoice detail',
    });
  }
}

export default function* invoiceUploadSaga() {
  yield takeLatest(ActionTypes.UPLOAD_INVOICE_REQUESTED, uploadInvoice);
  yield takeLatest(
    ActionTypes.FETCH_UPLOADED_INVOICES_REQUESTED,
    fetchUploadedInvoices
  );
  yield takeLatest(
    ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_REQUESTED,
    fetchUploadedInvoiceDetail
  );
}
